"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectSenderOnTopOption_1 = require("../actions/selectSenderOnTopOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var MessageListFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageListFull, _super);
    function MessageListFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSenderOnTopChange = function (ev, option) {
            selectSenderOnTopOption_1.default(option.key === 'true');
        };
        return _this;
    }
    MessageListFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var senderOnTop = owa_options_core_1.getFallbackValueIfNull(optionStore.showSenderOnTopInListView, userOptions.ShowSenderOnTopInListView);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + senderOnTop, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_messageList_firstLineSender,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_messageList_firstLineSubject,
                },
            ], onChange: this.onSenderOnTopChange, label: owa_options_strings_1.default.options_messageList_firstLineLabel }));
    };
    MessageListFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessageListFull);
    return MessageListFull;
}(React.Component));
exports.default = MessageListFull;
//# sourceMappingURL=SenderSubjectFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-subject-option/lib/components/SenderSubjectFull.js
// module id = 5125
// module chunks = 2